import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  AsyncDataItem,
  idleDataItem,
  isError,
  isLoading
} from '@pharvio/core/shared';
import { WidgetErrorComponent } from '../widget-error/widget-error.component';
import { ClickStopPropagationDirective } from '@pharvio/core/ui';

@Component({
  selector: 'app-kpi-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    MatIconModule,
    RouterLink,
    WidgetErrorComponent,
    ClickStopPropagationDirective
  ],
  templateUrl: './kpi-card.component.html'
})
export class KpiCardComponent {
  @Input({ required: true }) label = '';
  @Input({ required: true }) icon = '';
  @Input({ required: true }) colorClass = '';
  @Input({ required: true }) item: AsyncDataItem<unknown> = idleDataItem(null);
  @Input({ required: true }) value: string | number = '';
  @Input() suffix = '';
  @Input() link: string | null = null;
  @Output() retry = new EventEmitter<void>();

  protected readonly isLoading = isLoading;
  protected readonly isError = isError;
}
